import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { uploadFilesSet } from '@synergy/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { Demand } from '../../../../models/demand';
import { OverviewFormValues } from '../../models/overview-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export const DEMAND_DETAIL_OVERVIEW_SUBMIT = 'DEMAND_DETAIL_OVERVIEW_SUBMIT';
export const DEMAND_DETAIL_OVERVIEW_FETCH = 'DEMAND_DETAIL_OVERVIEW_FETCH';
export const DEMAND_DETAIL_OVERVIEW_RECEIVE = 'DEMAND_DETAIL_OVERVIEW_RECEIVE';
export const DEMAND_DETAIL_OVERVIEW_SAVE = 'DEMAND_DETAIL_OVERVIEW_SAVE';

export const submitOverview = (data: StepData<OverviewFormValues>) => ({
    type: DEMAND_DETAIL_OVERVIEW_SUBMIT,
    data,
});

export const fetchOverview = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.demands.get(id);
        if (response.success) {
            dispatch(uploadFilesSet(response.result.media));
            dispatch({ type: DEMAND_DETAIL_OVERVIEW_RECEIVE, demand: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveOverview = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        let response: ApiResult<Demand>;

        const demand = getState().demandDetail.overview.stepData.values as Partial<Demand>;

        if (demand.id) {
            response = await api.demands.patch(demand.id, demand);
        } else {
            response = await api.demands.post(demand as Demand);
        }

        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_OVERVIEW_RECEIVE, demand: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.demandSavedError')));
            return false;
        }

        return true;
    };
};
